let currentOrigin = window.location.origin;
// make it work locally too
if (currentOrigin === 'http://localhost:3000') {
    currentOrigin = 'https://ai.dev.sparkdit.com';
}

export const fetchComponentTypeFromURL = (url: string): 'form' | 'flow' | 'iframe' => {
    if (!url) {
        return 'iframe';
    }

    if (url.startsWith(`${currentOrigin}/forms`)) {
        return 'form';
    }
    if (url.startsWith(`${currentOrigin}/flows`)) {
        return 'flow';
    }

    return 'iframe';
};

export const transformMashupFields = (
    data: any[],
) => {
    return data.map(item => {
        return {
            id: item.id || item.fieldID || item.name,
            title: item.title,
            src: item.src,
            type: fetchComponentTypeFromURL(item.src),
            layout: {
                desktop: item.view?.desktop?.size,
                tablet: item.view?.tablet?.size,
                mobile: item.view?.mobile?.size,
            },
        };
    });
};


export const getComponentIdFromURL = (url: string, type: 'forms' | 'flows'): string | null => {
    const regex = new RegExp(`/${type}/([^/]+)/?$`);
    const match = url.match(regex);

    return match ? match[1] : null;
};
